export const documentThumbnailUrl = (source) => {
    if (!source) return "";
    const value = String(source);
    const marker = "/documents/";
    const markerIndex = value.indexOf(marker);
    if (markerIndex < 0) return value;

    const relativePath = value.slice(markerIndex + marker.length).split("?")[0].split("#")[0];
    return `/api/public/document-thumbnail/${relativePath
        .split("/")
        .filter(Boolean)
        .map((segment) => encodeURIComponent(decodeURIComponent(segment)))
        .join("/")}`;
};

export const applyImageFallback = (event, originalSource, fallbackSource = "") => {
    const image = event.currentTarget;
    const attemptedOriginal = image.dataset.attemptedOriginal === "true";
    const original = originalSource || "";

    if (original && !attemptedOriginal && image.src !== original) {
        image.dataset.attemptedOriginal = "true";
        image.src = original;
        return;
    }

    if (fallbackSource && image.src !== fallbackSource) {
        image.src = fallbackSource;
    }
};
